// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watchlist-reorder-drop-zone{padding:0;margin:0;transition:padding 200ms}.watchlist-reorder-drop-zone.watchlist-reorder-drop-zone-hover{padding-top:40px}", ""]);
// Exports
module.exports = exports;
